import { useMemo } from 'react';
const isImageFile = (attachment, sensitiveAttachment) => {
  var _attachment$fileMetad, _attachment$fileMetad2;
  if (sensitiveAttachment) return false;
  const type = (attachment === null || attachment === void 0 || (_attachment$fileMetad = attachment.fileMetadata) === null || _attachment$fileMetad === void 0 ? void 0 : _attachment$fileMetad.type) || '';
  const extension = (attachment === null || attachment === void 0 || (_attachment$fileMetad2 = attachment.fileMetadata) === null || _attachment$fileMetad2 === void 0 ? void 0 : _attachment$fileMetad2.extension) || '';
  const imageExtensions = ['gif', 'jpeg', 'jpg', 'png', 'tiff'];
  return type.startsWith('image/') || imageExtensions.includes(extension.toLowerCase());
};
export const useMessageAttachments = (messages, attachmentsMap, sensitiveAttachmentsMetadata) => {
  return useMemo(() => {
    const imagesArray = [];
    const attachmentsArray = [];
    messages.forEach(message => {
      var _message$attachments;
      const fileAttachments = (_message$attachments = message.attachments) === null || _message$attachments === void 0 ? void 0 : _message$attachments.find(attachment => attachment['@type'] === 'FILES');
      if (!fileAttachments || !Array.isArray(fileAttachments.fileIds)) return;
      fileAttachments.fileIds.forEach(fileId => {
        const attachment = attachmentsMap[fileId];
        const sensitiveAttachment = sensitiveAttachmentsMetadata === null || sensitiveAttachmentsMetadata === void 0 ? void 0 : sensitiveAttachmentsMetadata[fileId];
        const item = {
          fileId,
          attachment,
          sensitiveAttachment,
          sender: message.sender,
          sentDate: message.timestamp
        };
        if (isImageFile(attachment, sensitiveAttachment)) {
          imagesArray.push(item);
        } else {
          attachmentsArray.push(item);
        }
      });
    });
    return [imagesArray, attachmentsArray];
  }, [messages, attachmentsMap, sensitiveAttachmentsMetadata]);
};